module.exports = __webpack_public_path__ + "static/407etr-logo-2529c79bcca4325244211f77d6304008.jpeg";